<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="生产日期" prop="productionDate">
              {{ formatDate(formData.productionDate) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productName">
              {{ formData.productName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品规格" prop="productSpecName">
              {{ formData.productSpecName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料名称" prop="rawMaterialName">
              {{ formData.rawMaterialName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料号" prop="materialNumber">
              {{ formData.materialNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料生产日期" prop="rawMaterialProductionDate">
              {{ formatDate(formData.rawMaterialProductionDate) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料供应商" prop="rawMaterialSupplierName">
              {{ formData.rawMaterialSupplierName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="罐号" prop="tankNumber">
              {{ formData.tankNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="辅料名称" prop="auxiliaryMaterialName">
              {{ formData.auxiliaryMaterialName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="辅料生产日期" prop="auxiliaryMaterialDate">
              {{ formatDate(formData.auxiliaryMaterialDate) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="辅料供应商" prop="auxiliarySupplierName">
              {{ formData.auxiliarySupplierName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投料数量" prop="quantity">
              {{ formData.quantity === '' || formData.quantity == null ? '--' : formData.quantity }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button v-if="loadFailed" @click="loadDetails" class="global-button">重新加载</el-button>
          <el-button @click="$router.back()" class="global-button">返回</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'FeedingRecordDetail',
  data() {
    return {
      loading: false,
      loadFailed: false,
      formData: {
        feedingId: '', // 投料记录ID
        productionDate: '', // 生产日期
        productName: '', // 产品名称
        productSpecName: '', // 产品规格
        rawMaterialName: '', // 原料名称
        materialNumber: '', // 物料号
        rawMaterialProductionDate: '', // 原料生产日期
        rawMaterialSupplierName: '', // 原料供应商
        tankNumber: '', // 罐号
        auxiliaryMaterialName: '', // 辅料名称
        auxiliaryMaterialDate: '', // 辅料生产日期
        auxiliarySupplierName: '', // 辅料供应商
        quantity: '' // 投料数量
      }
    }
  },
  computed: {
    feedingId() {
      return this.$route.query.feedingId
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    formatDate(value, format = 'YYYY-MM-DD') {
      return value ? dayjs(value).format(format) : '--'
    },
    loadDetails() {
      if (!this.feedingId) {
        this.$message.warning('缺少记录ID')
        return
      }
      this.loading = true
      this.loadFailed = false
      return this.$axios.get(this.$apis.prodManage.selectScFeedingRecordById, {
        params: { feedingId: this.feedingId }
      }).then(res => {
        this.formData = res
      }).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.form {
  word-break: break-all;
}
</style>
